import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing components
import { WaveformSkeleton } from './skeleton-waveform';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
// ----------------------------------------------------------------------
const SkeletonStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
};
// ----------------------------------------------------------------------
export const PlayerSkeletonAudio = () => {
    return (_jsxs(Grid, { alignItems: 'center', justifyContent: 'space-between', height: "100%", width: "100%", children: [_jsxs(Stack, { alignItems: "center", flexDirection: "row", justifyContent: "center", height: '7.5vh', position: "relative", children: [_jsx(CircularProgress, { sx: { color: 'white', position: 'absolute' } }), _jsx(WaveformSkeleton, {})] }), _jsxs(Stack, { flexDirection: "column", sx: { p: 2 }, children: [_jsx(Skeleton, { height: 10, width: '100%', sx: SkeletonStyle }), _jsxs(Stack, { alignItems: 'flex-end', flexDirection: "row", justifyContent: 'space-between', children: [_jsx(Skeleton, { height: 40, width: '15%', sx: SkeletonStyle }), _jsx(Skeleton, { height: 40, width: '15%', sx: SkeletonStyle })] })] })] }));
};
